// Utils
import { isOverflown } from "./Dom";
import Sortable, { MultiDrag } from "sortablejs"
// Types
import type { SortableOptions } from "sortablejs";
let mounted = false
// Sortable.mount(new MultiDrag());
// functions
export const clickOutside = (callBack: () => any) => {
    return (node: HTMLElement) => {
        const handleClick = (event: Event) => {
            if (!node.contains(event.target as HTMLElement)) {
                callBack()
            }
        };

        document.addEventListener("click", handleClick, true);

        return {
            destroy() {
                document.removeEventListener("click", handleClick, true);
            },
        };
    }
}

export const clickOutsideAction = (node: HTMLElement, callBack: () => any) => {
    const handleClick = (event: Event) => {
        if (!node.contains(event.target as HTMLElement)) {
            callBack()
        }
    };

    document.addEventListener("click", handleClick, true);

    return {
        destroy() {
            document.removeEventListener("click", handleClick, true);
        },
    };
}

export const scrollTopBy = (node: HTMLElement, condition: boolean) => {
    //it weard scrollmoving when condition is turethy.
    //So scroll to top when ready to show condition . it make sence
    //i hope rest in my bed..
    if (!condition) {
        node.scrollTo(0, 0)
    }

    return {
        update(newCondition: boolean) {
            if (!newCondition) {
                node.scrollTo(0, 0)
            }
        }
    }
}

export const detectOverflow = (node: HTMLElement, updater: [any, (overFlow: boolean) => void, number?]) => {
    //I hope Designer consider perform . 
    let timeout: any
    const [_, callBack, time] = updater
    const resizeCallback = () => setTimeout(() => {
        if (timeout) {
            clearTimeout(timeout);
        }
        callBack(isOverflown(node))

    }, time || 0)


    callBack(isOverflown(node));
    window.addEventListener("resize", resizeCallback)

    return {
        update() {
            resizeCallback()
        },
        destroy() {
            window.removeEventListener("resize", resizeCallback)
        }
    }
}


export function sortableAction(el: HTMLElement, option?: SortableOptions) {
    const sortable = Sortable.create(el, option)

    return {
        update(option: SortableOptions) {
            for (const key in option) {
                const value = (option as any)[key];
                sortable.option(key as keyof SortableOptions, value)
            }
            // Sortable.utils.select
        },
        destroy() {
            // 
            sortable.destroy()
        }
    }
}